import {
  RETURN_REQUESTS_LIST_COUNT_ERROR,
  RETURN_REQUESTS_LIST_ERROR,
  CLEAR_SUBMIT_RETURN_REQUESTS_ACTION_ERROR,
  CLOSE_RETURN_REQUESTS_ACTION_MODAL,
  OPEN_RETURN_REQUESTS_ACTION_MODAL,
  SET_RETURN_REQUESTS_FORM,
  SET_RETURN_REQUESTS_LIST,
  SET_RETURN_REQUESTS_LIST_COUNT,
  SET_RETURN_REQUESTS_PENDING,
  SET_PAGE_SIZE_GLOBAL,
  SUBMIT_RETURN_REQUESTS_ACTION_ERROR,
  SUBMIT_RETURN_REQUESTS_ACTION_PENDING,
  SUBMIT_RETURN_REQUESTS_ACTION_SUCCESS,
} from "../returnRequests/actionTypes";

const initialState = {
  //-------------------------------RETURN_REQUESTS-LIST------------------------------------------
  isGetReturnRequestsPending: false,
  returnRequests: [],
  returnRequestsListCount: 0,
  returnRequestsListError: null,
  totalRecords: 0,
  //-------------------------------RETURN_REQUESTS-ACTIONS---------------------------------------
  isReturnRequestsActionModalOpen: false,
  isPending: false,
  errorMessage: null,
  returnRequestsForm: {},

  pageSizeGlobal: 0,
};

export default (localState = initialState, action) => {
  switch (action.type) {

    case SET_PAGE_SIZE_GLOBAL: {
      const { pageSize } = action.payload;
      return {
        ...localState,
        pageSizeGlobal: pageSize
      };
    }

    //-------------------------------RETURN_REQUESTS-LIST------------------------------------------
    case SET_RETURN_REQUESTS_PENDING: {
      return {
        ...localState,
        isGetReturnRequestsPending: true,
      };
    }
    case SET_RETURN_REQUESTS_LIST: {
      const { returnRequestsOdata } = action.payload;
      return {
        ...localState,
        isGetReturnRequestsPending: false,
        returnRequestsListError: null,
        returnRequests: returnRequestsOdata && returnRequestsOdata.value,
        totalRecords: returnRequestsOdata && returnRequestsOdata['@odata.count'],
      };
    }
    case SET_RETURN_REQUESTS_LIST_COUNT: {
      const { returnRequestsOdata } = action.payload;
      return {
        ...localState,
        returnRequestsListCount: returnRequestsOdata && returnRequestsOdata['@odata.count'],
      };
    }
    case RETURN_REQUESTS_LIST_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        returnRequestsListError: errorMessage,
        isGetReturnRequestsPending: false,
        returnRequests: [],
        totalRecords: 0
      };
    }
    case RETURN_REQUESTS_LIST_COUNT_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        returnRequestsListCount: 0
      };
    }

    //-------------------------------RETURN_REQUESTS-ACTIONS---------------------------------------
    case SUBMIT_RETURN_REQUESTS_ACTION_SUCCESS: {
      return {
        ...localState,
        isPending: false,
      };
    }
    case SET_RETURN_REQUESTS_FORM: {
      const { returnRequestsForm } = action.payload;
      return {
        ...localState,
        returnRequestsForm: returnRequestsForm
      };
    }
    case SUBMIT_RETURN_REQUESTS_ACTION_ERROR: {
      const { errorMessage } = action.payload;
      return {
        ...localState,
        errorMessage,
        isPending: false,
      };
    }
    case SUBMIT_RETURN_REQUESTS_ACTION_PENDING: {
      return {
        ...localState,
        isPending: true,
      };
    }
    case CLEAR_SUBMIT_RETURN_REQUESTS_ACTION_ERROR: {
      return {
        ...localState,
        errorMessage: null,
        isPending: false
      };
    }
    case OPEN_RETURN_REQUESTS_ACTION_MODAL: {
      return {
        ...localState,
        isReturnRequestsActionModalOpen: true,
        errorMessage: null,
      };
    }
    case CLOSE_RETURN_REQUESTS_ACTION_MODAL: {
      return {
        ...localState,
        isReturnRequestsActionModalOpen: false,
      };
    }

    default: {
      return localState;
    }
  }
};
